import { IStore } from '@/store/types';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const initialState = {
  envs: { data: [], loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations, getters } as IStore;
